import './CardKPI.scss';

const styles = {
  title: {
    color: 'rgb(107,114,128)',
    height: '20px',
    lineHeight: '20px',
  },
  value: {
    fontSize: '30px',
  },
  valueExtra: {
    color: 'rgb(107,114,128)',
  },
  card: {
    borderRadius: '8px',
  },
  text: {
    fontFeatureSettings: 'normal',
    fontSize: '14px',
    fontVariationSettings: 'normal',
  },
  footer: {
    height: '24px',
  },
};

const CardKPI = ({
  title,
  value,
  valueExtra,
  comparisonValue,
  comparisonText,
  positiveDelta,
  onClick,
  isActive,
}) => {
  const deltaIcon = positiveDelta
    ? 'ni ni-arrow-up-right'
    : 'ni ni-arrow-down-right';

  const deltaColors = positiveDelta
    ? 'bg-teal-dim text-teal'
    : 'bg-danger-dim text-danger';

  const comparisonColor = positiveDelta ? 'text-teal' : 'text-danger';

  const showDelta = positiveDelta === true || positiveDelta === false;

  const isClickable = typeof onClick === 'function';

  return (
    <div
      className={`card card-bordered mt-0 p-4 flex-1 w-100 ${
        isClickable ? 'card-kpi--clickable' : ''
      } ${isActive ? 'card-kpi--active rounded' : ''}`}
      style={styles.card}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex -- div with role="button" is interactive // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      onClick={isClickable ? onClick : undefined}
      onKeyDown={
        isClickable
          ? (e) => {
              if (e.key === 'Enter') onClick(e);
            }
          : undefined
      }
    >
      <p className="text-gray mb-1" style={styles.title}>
        {title}
      </p>
      <div className="flex w-full flex-row justify-start align-items-baseline">
        <h4 className="fw-medium mb-0" style={styles.value}>
          {value}
        </h4>
        <p className="text-gray ml-2" style={styles.text}>
          {valueExtra}
        </p>
      </div>
      <div className="flex w-full flex-row justify-start items-center space-x-2 mt-2">
        {showDelta && (
          <span
            className={`flex-shrink-0 inline-flex justify-center align-items-center cursor-default px-2 text-sm rounded-pill ${deltaColors}`}
            style={styles.footer}
          >
            <em className={`ni fs-12px fw-bold ${deltaIcon}`} />
          </span>
        )}

        {(comparisonValue || comparisonText) && (
          <div className="flex w-full flex-row justify-start items-center space-x-1 truncate ml-2">
            <p className={`${comparisonColor} mb-0`}>{comparisonValue || ''}</p>
            <p className="text-gray ml-1">{comparisonText || ''}</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default CardKPI;
